/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import Dropdown, {Options} from '@ion/dls/src/components/menus/Dropdown';

export type EventTypeChooserProps = {
  status?: string;
  onChange?: (status: string, label: string) => void;
  classes?: string;
  name?: string;
}

/**
 * Generates the Event types chooser dropdown labels and values based on
 * the translated status entries.
 */
const getOptions = (): Options[] => {
  const entries  = Object.entries(translate('admin-devices:choosers.eventTypes', {returnObjects: true}));
  const statuses = entries.map(([value, label]) => ({value, label})) as unknown as Options[];
  return statuses;
};

/**
 * The EventTypeChooser provides a list of localized CTC Event types values for display
 * within a dropdown list and allows the user to select a Status from the list which
 * will be returned to the client as the non-translated CTC Entity Status value.
 *
 * ```typescript
 *
 *     import {EventTypeChooser} from '@ion/dls/src/editors/';
 *
 *    // provide an Event types specific inline label ...
 *     <EventTypeChooser onChange(setStatus) />
 *
 */
export const EventTypeChooser = ({
  status,
  onChange,
  classes
}: EventTypeChooserProps) => {
  return (
    <div className={classes}>
      <Dropdown displaySelectedLabel
        value={status}
        options={getOptions()}
        fieldLabel={''}
        onChange={onChange ? function(e, target) {
          const {value, label} = target;
          onChange(value, label);
        } : null} />
    </div>
  );
};
export default EventTypeChooser;
